
    import { mapGetters } from 'vuex';
    import CompanyLogo from '@/components/Company/CompanyLogo';
    import Filters from '@/components/Utils/Filters';

    export default {
        name: 'CompanyHeader',

        components: {
            CompanyLogo,
        },

        mixins: [Filters],

        props: {
            companyNameTag: {
                type: String,
                default: 'h1',
            },
        },

        data() {
            return {
                logoSize: '',
            };
        },

        computed: {
            ...mapGetters('search', {
                $_companyName: 'companyName',
                $_companyLogoUrl: 'companyLogoUrl',
                $_companySquareLogoUrl: 'companySquareLogoUrl',
                $_companyLink: 'companyLink',
                $_companyPrimaryColor: 'companyPrimaryColor',
            }),

            primaryBrandColor() {
                return this.$_companyPrimaryColor || 'var(--light900)';
            },
        },
    };
